import React, { ReactElement, useMemo } from 'react';
import { Group } from 'types/groupService';
import { HorizontalTabBarStyled } from './styles';

interface Props {
  groups: Group[];
  activeGroup: Pick<Group, 'id' | 'name'>;
  onSelectGroup: (groupId: string) => void;
  children: ReactElement;
}

const EEGroupTabs: React.FC<Props> = ({ groups, activeGroup, onSelectGroup, children }) => {
  if (groups.length <= 1) {
    return <>{children}</>;
  }

  const tabs = useMemo(
    () =>
      groups.map((group) => ({
        id: group.id,
        label: activeGroup.id === group.id ? activeGroup.name : group.name,
      })),
    [groups, activeGroup],
  );

  const setActiveTab = (groupId: string): void => {
    if (groupId !== activeGroup.id) {
      onSelectGroup(groupId);
    }
  };

  return (
    <HorizontalTabBarStyled tabs={tabs} activeTabId={activeGroup.id} setActiveTab={setActiveTab}>
      {children}
    </HorizontalTabBarStyled>
  );
};

export default EEGroupTabs;
